import { createTheme } from '@mui/material';

// Initialize mui theme
export const theme = createTheme({
	palette: {
		primary: {
			light: '#rgb(139, 94, 255)',
			main: '#6F36FF',
			dark: '#rgb(77, 37, 178)',
			contrastText: '#FFFFFF',
		},
		secondary: {
			light: 'rgb(51, 51, 51)',
			main: '#000000',
			dark: '#000000',
			contrastText: '#fff',
		},
	},
});
